import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/about-us"

export const AddAboutUs = async (values) => {
  return await axiosInstance(options).post(`${path}/add`, values);
};

export const AboutUsDetails = async () => {
  return await axiosInstance(options).get(`${path}/details`);
};







